export const getFinalBonus = (shift: any) => {
  let bonusForThisShift = 0;

  shift?.promotionResults.map((promotion: any) => {
    if (promotion.progress >= promotion.promotion.requirementShiftCount) {
      let bonusForThisPromotion: number;

      if (promotion.promotion.rewardType === 'SURCHARGE_TO_THE_RATE') {
        bonusForThisPromotion = Math.round(promotion.promotion.rewardSum * (shift.durationPlan / 60));
      } else {
        bonusForThisPromotion = promotion.promotion.rewardSum;
      }

      if ((shift.moderation && shift.moderation.toPaymentBonus) || (!shift.moderation && shift.stage === 'FINISHED')) {
        bonusForThisShift += bonusForThisPromotion;
      }
    }
  });

  return bonusForThisShift;
};
